import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '../confirm-action-modal';
import type { TestSuccessModalProps } from './test-success-modal.type';

export const TestSuccessModal = ({
  isOpen,
  isLoading = false,
  onConfirm,
  onClose,
}: TestSuccessModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      isOpen={isOpen}
      title={t('backoffice.terminalTestSuccessModalTitle')}
      description={t('backoffice.terminalTestSuccessModalDescription')}
      confirmLabel={t('backoffice.terminalTestSuccessModalConfirm')}
      cancelLabel={t('backoffice.terminalsWizardCancel')}
      isLoading={isLoading}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
